<template>
  <form id="resetForm" class="login-form" @submit.prevent="resetPassword">
    <TextInput
        name="password"
        placeholder="Passwort"
        type="password"
        :custom-validate="validatePass"
        :custom-validate-initial="true"
        @value-changed="val=>pwchanged('pass1',val)"
        ref="pass1"
    />
    <TextInput
        name="passwordRepeat"
        placeholder="Passwort wiederholen"
        type="password"
        :custom-validate="validatePass"
        :custom-validate-initial="true"
        @value-changed="val=>pwchanged('pass2',val)"
        ref="pass2"
    />
    <div class="password-hints">
      <div :class="pass1.length >= 10 ? 'hint-ok' : 'hint-fail'">Mindestens 10 Zeichen</div>
      <div :class="pass1.length > 0 && pass2.length > 0 && pass1 === pass2 ? 'hint-ok' : 'hint-fail'" v-if="pass2.length > 0">Passwörter stimmen überein</div>
    </div>
    <PrimaryButton :full-width="true" text="Passwort speichern" :disabled="!formValid" />
  </form>
</template>

<script>
import PrimaryButton from "@/components/elements/PrimaryButton.vue";
import TextInput from "@/components/elements/TextInput.vue";

export default {
  data() {
    return {
      pass1: '',
      pass2: '',
      formValid: false,
    };
  },
  components: {
    PrimaryButton,
    TextInput,
  },
  methods: {
    async resetPassword() {
      const currentPath = window.location.pathname;
      const parts = currentPath.split("/").filter(Boolean);
      const token = parts[parts.length - 1];

      const data = {
        action: 'saveResettedPassword',
        password: this.pass1,
        token,
      }

      const res = await this.apiRequest("PATCH", "/account/passwordReset", data, false);
      if(!res.success) {
        this.showAPIError(res, "Fehler beim Speichern des Passworts.");
        return;
      }
      this.showNotice({
        type: 'success',
        content: 'Passwort erfolgreich gespeichert!',
      });
      this.$router.push('/');
    },
    validatePass() {
      return this.pass1.length >= 10 && this.pass1 === this.pass2
    },
    pwchanged(field, val) {
      if(field === 'pass1') {
        this.pass1 = val;
        if(this.pass1.length > 0 && this.pass2.length > 0) {
          this.$refs.pass2.validate({target: document.getElementById(this.$refs.pass2.fullHTMLId)}, true);
        }
      } else {
        this.pass2 = val;
        if(this.pass1.length > 0 && this.pass2.length > 0) {
          this.$refs.pass1.validate({target: document.getElementById(this.$refs.pass1.fullHTMLId)}, true);
        }
      }
    },
  }
}
</script>

<style scoped>
.password-hints {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  margin-bottom: 15px;
}

.hint-ok {
  color: #4caf50;
}

.hint-ok::before {
  content: '\2713\00a0\00a0';
}

.hint-fail {
  color: #999;
}

.hint-fail::before {
  content: '\2717\00a0\00a0';
}
</style>